import { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline'
import { authAPI } from '../services/api'
import Spinner from '../components/Spinner'
import PublicFooter from '../components/PublicFooter'

const VerifyEmail = () => {
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setStatus('error')
      setMessage('No verification token found in the link. Please check your email and try again.')
      return
    }

    authAPI.verifyEmail(token)
      .then(() => {
        setStatus('success')
      })
      .catch((err: any) => {
        setStatus('error')
        setMessage(
          err.response?.data?.detail ||
          'This verification link is invalid or has expired. Please request a new one.'
        )
      })
  }, [searchParams])

  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-primary-500 to-primary-700 px-4">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md text-center space-y-6">
        <h1 className="text-2xl font-bold text-gray-900">Email Verification</h1>

        {status === 'loading' && (
          <div className="flex flex-col items-center gap-3 text-gray-600">
            <Spinner size="md" />
            <p className="text-sm">Verifying your email address…</p>
          </div>
        )}

        {status === 'success' && (
          <div className="flex flex-col items-center gap-3">
            <CheckCircleIcon className="h-14 w-14 text-green-500" />
            <p className="text-gray-700 font-medium">Your email has been verified!</p>
            <p className="text-sm text-gray-500">You can now sign in to your account.</p>
            <Link
              to="/login"
              className="mt-2 inline-block px-6 py-2 rounded-md text-sm font-semibold text-white bg-primary-600 hover:bg-primary-700 transition-colors"
            >
              Sign in
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="flex flex-col items-center gap-3">
            <XCircleIcon className="h-14 w-14 text-red-500" />
            <p className="text-gray-700 font-medium">Verification failed</p>
            <p className="text-sm text-gray-500">{message}</p>
            <Link
              to="/login"
              className="mt-2 inline-block px-6 py-2 rounded-md text-sm font-semibold text-white bg-primary-600 hover:bg-primary-700 transition-colors"
            >
              Back to sign in
            </Link>
          </div>
        )}
      </div>
      <PublicFooter />
    </main>
  )
}

export default VerifyEmail
